import { HttpContextToken } from '@angular/common/http';

/**
  A HTTP context variable that controls whether a toast should be automatically displayed for any
  error response to a given request. If set to false, the code making the request must handle
  or display any errors itself.

  This is set to true by default for compatibility with existing components.

  As an exception, authentication and session expiration errors are handled automatically
  regardless of the value of this variable.
*/
export const AUTOMATIC_TOAST_ON_ERROR = new HttpContextToken(() => true);
